export async function initHeadroom(options) {
    let { Headroom } = await import(/* webpackMode: "lazy" */ './headroom.js');

    return new Headroom(options);
}
